import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default function certificatesReducer(state = initialState.certificates, action) {

    let selected;

    switch (action.type) {

        case types.LOAD_CERTIFICATES_SUCCESS :
            return {...state, ...action};

        case types.INIT_SELECTED_CERTIFICATES :
            selected = action.certificates.map(certificate => certificate.id);
            return {...state, ...{selected}};

        case types.SELECT_THE_CERTIFICATE :

            selected = [...state.selected, action.certificateId];
            return {...state, ...{selected}};

        case types.DESELECT_THE_CERTIFICATE :

            selected = state.selected.filter((item, index) => {
                return index !== state.selected.indexOf(action.certificateId);
            });

            return {...state, ...{selected}};

        case types.UPDATE_THE_CERTIFICATES :
            return state;

        case types.FILTER_CERTIFICATES :
            return filterCertificates(state, action);

        default:
            return state;
    }
}

const filterCertificates = (state, action) => {

    let stateWithResetedFilter = resetFiltering(state);

    if (! action.query) {
        return stateWithResetedFilter;
    }

    let certificates = stateWithResetedFilter.all;

    certificates = filterBySubstring(certificates, action.query);

    return {...state, ...{all: certificates}};
};

const resetFiltering = (state) => {
    const certificates = state.all.map(c => {
        return {...c, ...{hidden: undefined}};
    });

    return {...state, ...{all: certificates}};
};

const filterBySubstring = (entries, substring, marker = 'hidden') => {
    // normilize substring
    substring = substring.toLowerCase();

    return entries.map(entry => {
        // normilize an entry name
        let entryName = entry.name.toLowerCase();

        if (entryName.indexOf(substring) === -1) {
            entry[marker] = true;
        }

        return entry;
    });
};


// WEBPACK FOOTER //
// ./web/src/reducers/certificatesReducer.js